import dayjs from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useTimer } from 'react-timer-hook'

interface Props {
  gift_date: string
}

const GiftTimer: FC<Props> = ({ gift_date }) => {
  const { t } = useTranslation()
  const expiryDate = dayjs(gift_date).add(1, 'day').toDate()
  const nowDate = new Date()

  const { hours, minutes, seconds } = useTimer({ expiryTimestamp: expiryDate })

  if (nowDate > expiryDate) return null

  return (
    <div className='text-center'>
      <p className='text-s14'>
        <span className='text-secondary'>{t('can_edit_label', { ns: 'gift' })} &nbsp;</span>
        <b>
          {hours < 10 && '0'}
          {hours}:{minutes < 10 && '0'}
          {minutes}:{seconds < 10 && '0'}
          {seconds}
        </b>
      </p>
    </div>
  )
}
export default GiftTimer
